/* Label Shalini · v5 Noir — runtime */
(function(){
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = matchMedia('(hover: none)').matches || window.innerWidth < 900;

  function preloader(){
    if(document.getElementById('v5Pre')) return;
    var pre = document.createElement('div');
    pre.id='v5Pre'; pre.className='v5-pre';
    var letters = 'LABEL SHALINI'.split('').map(function(c,i){
      return '<span style="display:inline-block;animation:v5fIn .9s cubic-bezier(.19,1,.22,1) '+(i*60)+'ms both">'+(c===' '?'&nbsp;':c)+'</span>';
    }).join('');
    pre.innerHTML='<div class="v5-pre__brand">'+letters+'</div><div class="v5-pre__bar"></div><div class="v5-pre__note">Entering the Atelier</div>';
    var s=document.createElement('style');
    s.textContent='@keyframes v5fIn{from{transform:translateY(110%);opacity:0}to{transform:none;opacity:1}}';
    document.head.appendChild(s);
    document.body.appendChild(pre);
    window.addEventListener('load',function(){
      setTimeout(function(){pre.classList.add('gone');setTimeout(function(){pre.remove()},900)},700);
    });
  }

  function cursor(){
    if(isTouch||reduced) return;
    var ring=document.createElement('div');ring.className='v5-ring';
    var dot=document.createElement('div');dot.className='v5-dot';
    document.body.appendChild(ring);document.body.appendChild(dot);
    var cx=0,cy=0,rx=0,ry=0;
    document.addEventListener('mousemove',function(e){
      cx=e.clientX;cy=e.clientY;
      dot.style.transform='translate('+cx+'px,'+cy+'px) translate(-50%,-50%)';
    });
    (function raf(){
      rx+=(cx-rx)*.18;ry+=(cy-ry)*.18;
      ring.style.transform='translate('+rx+'px,'+ry+'px) translate(-50%,-50%)';
      requestAnimationFrame(raf);
    })();
    document.addEventListener('mouseover',function(e){
      var t=e.target;if(!t.closest) return;
      if(t.closest('.product-card, .card-product, [class*="collection-card"], .image-banner, img')) {
        document.body.classList.add('v5-m');document.body.classList.remove('v5-h');
      } else if(t.closest('a, button, [role=button], input, select, .btn, .button')) {
        document.body.classList.add('v5-h');document.body.classList.remove('v5-m');
      } else {
        document.body.classList.remove('v5-h','v5-m');
      }
    });
  }

  function scrollBits(){
    var bar=document.createElement('div');bar.className='v5-scroll-bar';document.body.appendChild(bar);
    var top=document.createElement('button');top.className='v5-top';top.setAttribute('aria-label','Back to top');
    top.innerHTML='<svg viewBox="0 0 24 24"><path d="M12 19V5M5 12l7-7 7 7" stroke-linecap="round"/></svg>';
    document.body.appendChild(top);
    top.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
    window.addEventListener('scroll',function(){
      var h=document.documentElement;
      var s=h.scrollTop/(h.scrollHeight-h.clientHeight);
      bar.style.width=(s*100)+'%';
      top.classList.toggle('on',h.scrollTop>600);
    },{passive:true});
  }

  // ===== Loox reviews → horizontal carousel =====
  // Loox renders asynchronously. Watch the DOM and convert the
  // reviews list into a single-row scroll-snap carousel once it appears.
  function looxCarousel(){
    var converted = new WeakSet();

    function convert(grid){
      if(converted.has(grid)) return;
      converted.add(grid);
      var children = Array.from(grid.children);
      if(children.length < 2) return;
      // The reviews list — turn into a horizontal carousel
      grid.style.cssText += ';display:flex !important;flex-wrap:nowrap !important;'+
        'overflow-x:auto !important;scroll-snap-type:x mandatory;'+
        'gap:16px !important;grid-template-columns:none !important;'+
        'padding:6px 4px 18px !important;-webkit-overflow-scrolling:touch;'+
        'scrollbar-width:thin;';
      children.forEach(function(card){
        card.style.cssText += ';flex:0 0 auto !important;width:280px !important;'+
          'max-width:82vw !important;scroll-snap-align:start !important;'+
          'background:#fff;border:1px solid rgba(26,22,18,.10);border-radius:6px;'+
          'overflow:hidden;box-shadow:0 2px 10px rgba(26,22,18,.04);'+
          'display:flex;flex-direction:column;';
      });
    }

    function findAndConvert(root){
      // Look for any element inside a Loox container that has 4+ direct
      // children that look like cards (a typical reviews grid)
      var candidates = (root||document).querySelectorAll(
        '#looxReviews, .loox-reviews-default, .loox-rebuy, '+
        '.loox-grid-container, [class*="loox-grid"], [data-loox-reviews]'
      );
      candidates.forEach(function(container){
        // Walk down to find the actual grid (the parent of card siblings)
        var walker = container.querySelectorAll('div, ul, ol, section');
        for(var i=0;i<walker.length;i++){
          var el = walker[i];
          if(el.children.length >= 3){
            var cs = window.getComputedStyle(el);
            if(cs.display === 'grid' || (cs.display === 'flex' && cs.flexWrap !== 'nowrap')){
              convert(el);
            }
          }
        }
      });
    }

    findAndConvert();
    // Re-run whenever new nodes appear (Loox loads async)
    var mo = new MutationObserver(function(muts){
      var hasNew = muts.some(function(m){return m.addedNodes.length});
      if(hasNew) findAndConvert();
    });
    mo.observe(document.body, {childList:true, subtree:true});
    // Final pass after window load
    window.addEventListener('load', function(){ setTimeout(findAndConvert, 1500); });
  }

  function init(){preloader();cursor();scrollBits();looxCarousel()}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
